import React from 'react';
import styles from './A23RoomTile.module.css';
import gameAssets from '@themed-assets';
import useGameDefinition from '../../../hooks/data/useGameDefinition';
import { RUPEE_SYMBOL } from '@/Poker/data/Constants';
import { useNavigate } from 'react-router';
import useRoomDetails from '@/src/hooks/data/useRoomDetails';
import { useDispatch } from 'react-redux';
import { showBuyInPopupInLobby } from '@/Poker/redux/slices/lobbySlice';
import { IoMdStarOutline } from 'react-icons/io';
import { MdOutlineStar } from 'react-icons/md';
import { FaUserAlt } from 'react-icons/fa';
import useAddGameToFavorite from '@/src/hooks/utils/useAddGameToFavorite';
import useRestrictions from '@/src/hooks/data/useRestrictions';
import { parseDecimalValuesOfNumber } from '@/Common/utils/GameUtils';

const A23RoomTile = ({ roomId }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const roomDetails = useRoomDetails(roomId);
    const gameDefinition = useGameDefinition(roomDetails?.gameDefs[0] || {});
    const { handleSaveFavoriteRequest } = useAddGameToFavorite({ isGame: false });
    const { restrictionCheck } = useRestrictions();


    if (!roomDetails || !roomId) {
        return null;
    }


    const handleGameTileClick = () => restrictionCheck(() => {
        if (roomDetails.isTableListingEnabled) {
            return navigate(`/cashLobbyRoom/${roomDetails.roomId}`);
        } else {
            if (gameDefinition) {
                return dispatch(showBuyInPopupInLobby({ gameDefinition }));
            } else {
                console.warn('Error in clicking on game tile. No game definition available.')
            }
        }
    }, true)

    return (
        <div className={styles.container} onClick={handleGameTileClick}>
            <div className={styles.header}>
                <div className={[styles.nameContainer]}>
                    <span>{roomDetails.tableName}</span>
                    {
                        roomDetails.isTableListingEnabled
                            ?
                            <img src={gameAssets.layersIcon} alt="Game layers" />
                            : null
                    }
                </div>
                <div className={styles.favoriteContainer} onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    handleSaveFavoriteRequest(roomDetails?.roomId);
                }}>
                    {
                        roomDetails.isFavorite
                            ?
                            <MdOutlineStar color={'var(--color-accent-theme)'} />
                            :
                            <IoMdStarOutline color={'var(--color-secondary)'} />
                    }
                </div>
            </div>
            <div className={styles.details}>
                <div className={`${styles.infoItem} ${styles.alignStart}`}>
                    <span className={styles.label}>Blinds</span>
                    <div className={styles.value}>
                        <img className={styles.cashIcon} src={gameAssets.cashIcon} alt="Blinds amount" />
                        <span>{parseDecimalValuesOfNumber(roomDetails.smallBlind, 2, true, true)} / {parseDecimalValuesOfNumber(roomDetails.bigBlind, 2, true, true)}</span>
                    </div>
                </div>
                <div className={`${styles.infoItem} ${styles.alignCenter}`}>
                    <span className={styles.label}>Playing</span>
                    <div className={styles.value}>
                        <FaUserAlt color={'var(--color-success)'} size={10} style={{ marginRight: '2px' }} />
                        <span>{roomDetails.onlineCount}</span>
                    </div>
                </div>
                <div className={`${styles.infoItem} ${styles.alignEnd}`}>
                    <span className={styles.label}>Min Buy-In</span>
                    <div className={styles.buyInValue}>
                        {/* <img src={gameAssets.cashBill} alt="Minimum buy-in amount" /> */}
                        <span style={{ fontWeight: 700, fontSize: 16 }}>{RUPEE_SYMBOL}</span>
                        <span>{parseDecimalValuesOfNumber(roomDetails.minBuyInAmount, 2, true, true)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default A23RoomTile; 